import axios from "../axiosPlugin.js";

const _TRADE_GROUP = "/api/tradeGroup";

export const getListService = data => {
  return axios({
    url: `${_TRADE_GROUP}/list`,
    method: "get",
    data: { data },
  });
};

export const approveService = data => {
  return axios({
    url: `${_TRADE_GROUP}/approve?brandId=${data.brandId}`,
    method: "post",
    data: {},
  });
};

export const createService = data => {
  return axios({
    url: `${_TRADE_GROUP}/create`,
    method: "post",
    data: { data },
  });
};

export const deleteService = data => {
  return axios({
    url: `${_TRADE_GROUP}/delete/${data.id}`,
    method: "get",
    data: {},
  });
};

export const getDetailService = data => {
  return axios({
    url: `${_TRADE_GROUP}/detail/${data.id}`,
    method: "get",
    data: {},
  });
};

export const updateService = data => {
  return axios({
    url: `${_TRADE_GROUP}/update`,
    method: "post",
    data: { data },
  });
};